import { Partner } from '../../models/partners.interfaces';

export const Partners4ItemsMocks: Partner[] = [
  {
    id: 'earnMilesWithEveryLyft',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/lyft-logo.svg',
      alt: 'Lyft Logo image'
    },
    title: 'Earn Miles With Every Lyft',
    action: {
      label: 'Link Account',
      url: 'https://www.deltalyft.com'
    }
  },
  {
    id: 'earnMilesWithStarbucks',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/starbucks-logo.svg',
      alt: 'Starbucks Logo image'
    },
    title: 'Earn Miles With Starbucks',
    action: {
      label: 'Link Account',
      url: 'https://www.deltalyft.com/'
    }
  },
  {
    id: 'earnMileWithAirbnb',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/airbnb-logo.svg',
      alt: 'Airbnb Logo image'
    },
    title: 'Earn 1 Mile per $1 spent with Airbnb',
    action: {
      label: 'Book Now',
      url: 'https://www.deltaairbnb.com'
    }
  },
  {
    id: 'earnMilesWithEveryOrder',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/instacart-logo.svg',
      alt: 'Instacart Logo image'
    },
    title: 'Earn Miles With Every Order',
    action: {
      label: 'Link Account',
      url: 'https://www.delta.com/instacart'
    }
  }
];
